import { SET_VISIBILITY, UPDATE_VISIBILITY } from 'constants/actionTypes';
import update from 'immutability-helper';

const initialState = {
  //visibility should be fetched with api
  visibility: []
};

export default function(state = initialState, action) {
  switch (action.type) {
  case UPDATE_VISIBILITY:
    return {
      ...state,
      visibility: formVisibility(state.visibility, action.changedFields)
    };

  case SET_VISIBILITY: 
    return {
      ...state,
      visibility: action.visibility
    };
    
  default: return state;
  }
}

const formVisibility = (visibility, changes) => {
  const replacedVisibility = visibility.filter(object => 
    !changes.some(changed => changed.field === object.field && changed.type === object.type
    )).concat(changes);
  return replacedVisibility;
};